/*
 * Confidential and Proprietary.
 * Do not distribute without 1-800-Flowers.com, Inc. consent.
 * Copyright 1-800-Flowers.com, Inc. 2019. All rights reserved.
 */

import restClient from '../../app/helpers/restClient';
import { getAccessTokenSafely } from '../../state/ducks/Member/ducks/Auth/Plugin/auth/auth';

const BASE_URL = 'ssp/favorites/contact';

const wcEnv = { rootUri: '/' };
export const addFavoriteApi = async (contactId, payload, params, headers) => {
    const token = await getAccessTokenSafely();
    const resourcePage = `${BASE_URL}/${contactId}/favorite`;
    return restClient
        .postFacade(wcEnv, resourcePage, token, payload, params, { ...headers, 'Cache-Control': 'no-store' }, false)
        .then((res) => res.data);
};

/**
 * Get a favorite contact
 * GET /r/api/ssp/favorites/contact/${favoriteContactId}
 */
export const getFavorite = async (favoriteContactId, params, headers) => {
    const token = await getAccessTokenSafely();
    const resourcePage = `${BASE_URL}/${favoriteContactId}`;
    return restClient
        .getFacade(wcEnv, resourcePage, token, params, { ...headers, 'Cache-Control': 'no-store' }, false)
        .then((res) => res.data);
};
/**
 * Delete a favorite contact
 * DELETE /r/api/ssp/favorites/contact/${favoriteContactId}/favorites/bulk-delete
 */
export const deleteFavorite = async (contactId, payload) => {
    const token = await getAccessTokenSafely();
    const resourcePage = `${BASE_URL}/${contactId}/favorites/bulk-delete`;
    return restClient
        .deleteFacade(wcEnv, resourcePage, token, payload, null, null, false)
        .then((res) => res);
};
